export default {"src":"/_next/static/media/refrigerator.08837c06.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};